/**
 * Utility functions for password hashing
 * Uses CryptoJS with SHA-256 hashing (GDPR compliant, one-way)
 */

import CryptoJS from 'crypto-js';

/**
 * Hash a password using SHA-256 (one-way hashing for GDPR compliance)
 * @param {string} password - Plain text password (6 digits)
 * @returns {string} - SHA-256 hashed password
 */
export const encryptPassword = (password) => {
    if (!password) return '';

    try {
        // Use SHA-256 for GDPR-compliant one-way hashing
        const hashed = CryptoJS.SHA256(password).toString();
        return hashed;
    } catch (error) {
        console.error('Hashing error:', error);
        throw new Error('Failed to hash password');
    }
};

/**
 * @deprecated Password hashing is one-way with SHA-256, cannot be decrypted
 * This function is kept for backwards compatibility but always returns empty string
 * @param {string} encryptedPassword - Hashed password
 * @returns {string} - Empty string (hashing is one-way)
 */
export const decryptPassword = (encryptedPassword) => {
    console.warn('decryptPassword is deprecated: SHA-256 hashing is one-way and cannot be reversed');
    return '';
};

/**
 * Validate password format (6 digits)
 * @param {string} password - Password to validate
 * @returns {boolean} - True if valid, false otherwise
 */
export const validatePassword = (password) => {
    if (!password) return false;

    // Must be exactly 6 digits
    const passwordRegex = /^\d{6}$/;
    return passwordRegex.test(password);
};
